export const RQ_UPDATE_Admin_PROFILE_API = {
  url: 'api/user/<%= id %>/updateRequiredFields',
  method: 'PUT',
  auth: true,
};

export const RQ_UPDATE_User_PROFILE_API = {
  url: 'api/user/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
};
